import React from 'react'
import Head from "next/head";
import Testimonials from '@/components/Testimonials';

const testimonials = () => {
  return (
    <>
      <Head>
        <title>Discover Real Success Stories with QueueBuster POS Solutions</title>
        <link rel="canonical" href="https://queuebuster.co/testimonials" />
        <link rel="alternate" href="https://queuebuster.co/testimonials" hrefLang="en-us" />
        <meta name="description" content="Explore how leading brands like CocoCart, Henney Bear, and Pure Home & Living revolutionized their operations with QueueBuster POS for seamless efficiency." />
        <meta property="og:title" content="Real Business Success Stories: How QueueBuster POS Transformed Leading Brands' Operations" />
        <meta property="og:description" content="Hear from CocoCart, Henney Bear, and Pure Home & Living about how QueueBuster POS." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/ALL-IN-ONE_OG.jpg" />
        <meta property="og:url" content="https://queuebuster.co/testimonials" />
      </Head>
      <Testimonials />
    </>
  )
}

export default testimonials